/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : labCar.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 25-07-2024
 * @description Lab Car API details to perform a action
 */

import actionType from "../actionTypes";

const labCar = {
  get_project_details_mind_map_pa: {
    api_name: "/PCM/project/mind-map",
    https_method: "GET",
    action_type: actionType.GET_PROJECT_DETAILS_MIND_MAP_PA,
    description: "",
  },
  get_project_details_pa: {
    api_name: "/PCM/project/details",
    https_method: "GET",
    action_type: actionType.GET_PROJECT_DETAILS_PA,
    description: "",
  },
  get_variant_details: {
    api_name: "/PCM/project/variants",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_ee_components_pa: {
    api_name: "/VLC/ee_components/details",
    https_method: "GET",
    action_type: actionType.GET_EE_COMPONENTS_PA,
    description: "",
  },
  get_sw_modules_pa: {
    api_name: "/VLC/swm/details",
    https_method: "GET",
    action_type: actionType.GET_SW_MODULES_PA,
    description: "",
  },
  get_project_details_mind_map: {
    api_name: "/PCM/project/mind-map",
    https_method: "GET",
    action_type: actionType.GET_PROJECT_DETAILS_MIND_MAP,
    description: "",
  },
  get_project_details: {
    api_name: "/PCM/project/details",
    https_method: "GET",
    action_type: actionType.GET_PROJECT_DETAILS,
    description: "",
  },
  get_ee_components: {
    api_name: "/VLC/ee_components/details",
    https_method: "GET",
    action_type: actionType.GET_EE_COMPONENTS,
    description: "",
  },
  get_ee_components_count: {
    api_name: "/VLC/ee_components/details",
    action_type: actionType.GET_EE_COMPONENTS_COUNT,
    https_method: "GET",
    description: "",
  },
  add_ee_component: {
    api_name: "/VLC/ee_components/add",
    https_method: "POST",
    action_type: actionType.Add_EE_COMPONENT,
    description: "",
  },
  update_ee_component: {
    api_name: "/VLC/ee_components/details",
    https_method: "PUT",
    action_type: actionType.UPDATE_EE_COMPONENT,
    description: "",
  },
  replace_ee_component: {
    api_name: "/VLC/ee_components/replace",
    https_method: "POST",
    action_type: actionType.REPLACE_EE_COMPONENT,
    description: "",
  },
  get_sw_modules: {
    api_name: "/VLC/swm/details",
    https_method: "GET",
    action_type: actionType.GET_SW_MODULES,
    description: "",
  },
  get_main_sw_modules: {
    api_name: "/VLC/swm/details",
    https_method: "GET",
    action_type: actionType.GET_MAIN_SW_MODULES,
    description: "",
  },
  get_linked_sw_modules: {
    api_name: "/VLC/swm/details",
    https_method: "GET",
    action_type: actionType.GET_LINKED_SW_MODULES,
    description: "",
  },
  add_sw_module: {
    api_name: "/VLC/swm/add",
    https_method: "POST",
    action_type: actionType.Add_SW_MODULE,
    description: "",
  },
  update_sw_module: {
    api_name: "/VLC/swm/details",
    https_method: "PUT",
    action_type: actionType.Update_SW_MODULE,
    description: "",
  },
  replace_sw_module: {
    api_name: "/VLC/swm/replace",
    https_method: "POST",
    action_type: actionType.REPLACE_SW_MODULE,
  },
  link_sw_module: {
    api_name: "/VLC/swm/link",
    https_method: "PUT",
    action_type: actionType.LINK_SW_MODULE,
    description: "",
  },
  unlink_sw_module: {
    api_name: "/VLC/swm/un-link",
    https_method: "PUT",
    action_type: actionType.UNLINK_SW_MODULE,
    description: "",
  },
  get_ee_components_main: {
    api_name: "/VLC/ee_components/details",
    https_method: "GET",
    action_type: actionType.GET_EE_COMPONENTS_MAIN,
    description: "",
  },
  get_ee_components_linked: {
    api_name: "/VLC/ee_components/details",
    https_method: "GET",
    action_type: actionType.GET_EE_COMPONENTS_LINKED,
    description: "",
  },
  get_ee_components_main_linked: {
    api_name: "/VLC/ee_components/details",
    https_method: "GET",
    action_type: actionType.GET_EE_COMPONENTS_MAIN_LINKED,
    description: "",
  },
  // Change logs
  get_ee_components_change_logs: {
    api_name: "/VLC/ee_components/change-logs",
    https_method: "GET",
    action_type: actionType.GET_EE_COMPONENT_CHANGE_LOGS,
    description: "",
  },
  get_sw_modules_change_logs: {
    api_name: "/VLC/swm/change-logs",
    https_method: "GET",
    action_type: actionType.GET_SW_MODULE_CHANGE_LOGS,
    description: "",
  },
  // New
  get_ee_components_new: {
    api_name: "/VLC/ee_components/details",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_sw_modules_new: {
    api_name: "/VLC/swm/details",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  link_ee_component: {
    api_name: "/VLC/ee_components/link",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  unlink_ee_component: {
    api_name: "/VLC/ee_components/un-link",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  get_ee_intersections: {
    api_name: "/VLC/ee_components/intersections",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  //Action Type
  update_action_type: {
    api_name: "/PCM/project/module/action_type",
    https_method: "PUT",
    action_type: actionType.update_action_type,
    description: "",
  },
  update_swm_action_type: {
    api_name: "/VLC/swm/action_type",
    https_method: "PUT",
    action_type: actionType.UPDATE_SWM_ACTION_TYPE,
    description: "",
  },
  // Lock/UnLock EE Component
  lock_unlock_ee_component: {
    api_name: "/VLC/ee_components/lock-unlock",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  // Lock/UnLock Software Module
  lock_unlock_software_module: {
    api_name: "/VLC/swm/lock-unlock",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  // Vehicle Systems
  add_vehicle_system: {
    api_name: "/VLC/vehicle_systems/add",
    https_method: "POST",
    action_type: "",
    description: "Add Vehicle System",
  },
  get_vehicle_systems: {
    api_name: "/VLC/vehicle_systems/details",
    https_method: "GET",
    action_type: actionType.GET_VEHICLE_SYSTEMS_PR,
    description: "Get Vehicle Systems",
  },
  get_vehicle_systems_all: {
    api_name: "/VLC/vehicle_systems/details",
    https_method: "GET",
    action_type: "",
    description:
      "Get Vehicle Systems, the data will not be stored in the redux store",
  },
  edit_vehicle_system: {
    api_name: "/VLC/vehicle_systems/replace",
    https_method: "POST",
    action_type: "",
    description: "Edit Vehicle System",
  },
  vehicle_system_logs: {
    api_name: "/VLC/vehicle_systems/change-logs",
    https_method: "GET",
    action_type: "",
    description: "Get Vehicle System Logs",
  },
  // Vehicle Components
  add_vehicle_component: {
    api_name: "/VLC/vehicle_components/add",
    https_method: "POST",
    action_type: "",
    description: "Add Vehicle Component",
  },
  get_vehicle_components: {
    api_name: "/VLC/vehicle_components/details",
    https_method: "GET",
    action_type: actionType.GET_VEHICLE_COMPONENTS,
    description: "Get Vehicle Components",
  },
  get_vehicle_components_all: {
    api_name: "/VLC/vehicle_components/details",
    https_method: "GET",
    action_type: "",
    description:
      "Get Vehicle Components, the data will not be stored in the redux store",
  },
  get_ee_actions_details: {
    api_name: "/VLC/ee_components/change_impact_assessment/ee_actions",
    https_method: "GET",
    action_type: "",
    description: "Get EE Action Details",
  },
  edit_vehicle_component: {
    api_name: "/VLC/vehicle_components/replace",
    https_method: "POST",
    action_type: "",
    description: "Edit Vehicle Component",
  },
  vehicle_component_logs: {
    api_name: "/VLC/vehicle_components/change-logs",
    https_method: "GET",
    action_type: "",
    description: "Get Vehicle Component Logs",
  },

  // recreate apis
  get_parent_ee: {
    api_name: "/RCS/ee/get",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  recreate_ee: {
    api_name: "/RCS/ee/recreate",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_parent_swm: {
    api_name: "/RCS/swm/get",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_parent_vs: {
    api_name: "/RCS/vs/get",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  recreate_vs: {
    api_name: "/RCS/vs/recreate",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_parent_vc: {
    api_name: "/RCS/vc/get",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  recreate_vc: {
    api_name: "/RCS/vc/recreate",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_parent_ee_link: {
    api_name: "/RCS/ee_link/get",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  recreate_ee_link: {
    api_name: "/RCS/ee_link/recreate",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_parent_swm_link: {
    api_name: "/RCS/swm_link/get",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  recreate_swm_link: {
    api_name: "/RCS/swm_link/recreate",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  updateEEAttribute: {
    api_name: "/VLC/attribute/ee/update",
    https_method: "PUT",
  },
  updateSWMAttribute: {
    api_name: "/VLC/attribute/swm/update",
    https_method: "PUT",
  },
  updateVSAttribute: {
    api_name: "/VLC/attribute/vs/update",
    https_method: "PUT",
  },
  updateVCAttribute: {
    api_name: "/VLC/attribute/vc/update",
    https_method: "PUT",
  },
};

export default labCar;
